import {
  MemberTransferDataView,
  MemberTransferReasonDto,
  MemberTransferRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';
import type {
  AuditMemberTransferRequest,
  CreateMemberTransferRequest,
  UpdateMemberTransferRequest,
} from '@act/shared/types';

export const memberTransferRequests = {
  getMemberTransferReasons: EndpointDefinition.get<
    MemberTransferReasonDto[],
    null
  >({
    name: 'getMemberTransferReasons',
    route: '/users/member-transfer-requests/reasons',
  }),

  getMemberTransferRequestsById: EndpointDefinition.get<
    MemberTransferRequestDto[],
    { ids: number[] }
  >({
    name: 'getMemberTransferRequestsById',
    route: '/users/member-transfer-requests',
  }),

  createMemberTransferRequest: EndpointDefinition.post<
    MemberTransferDataView,
    CreateMemberTransferRequest,
    null
  >({
    name: 'createMemberTransferRequest',
    route: '/users/member-transfer-requests',
  }),

  updateMemberTransferRequest: EndpointDefinition.patch<
    MemberTransferRequestDto,
    UpdateMemberTransferRequest,
    { id: number }
  >({
    name: 'updateMemberTransferRequest',
    route: '/users/member-transfer-requests/:id',
  }),

  getPendingMemberTransferRequestsForAuditor: EndpointDefinition.get<
    MemberTransferRequestDto[],
    { guideId: string }
  >({
    name: 'getPendingMemberTransferRequestsForAuditor',
    route: '/users/member-transfer-requests/auditor/:guideId',
  }),

  auditMemberTransferRequest: EndpointDefinition.patch<
    MemberTransferDataView,
    AuditMemberTransferRequest,
    { id: number }
  >({
    name: 'auditMemberTransferRequest',
    route: '/users/member-transfer-requests/audit/:id',
  }),
};
